import { isIdXboxGameInformationXboxNetworkFormValid } from "../../../../helpers/formValidation";
import { GameInformationXboxNetworkDataType, SubFormsDataTypes } from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const XboxNetworkDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const xboxNetworkData = data as GameInformationXboxNetworkDataType;
    if (!xboxNetworkData) {
      return { result: true };
    }

    const validSchema = await isIdXboxGameInformationXboxNetworkFormValid(xboxNetworkData);
    return { result: validSchema };
  },
};
